import { useState } from 'react';
import './App.css';
import MainForm from './components/mainForm';
import Navbar from './components/navbar';
import AppContext from './context/formContext'

function App() {

  const [form, setForm] = useState(1);
  
  return (
    <div className="App">
      <AppContext.Provider value={{form,setForm}}>
        <Navbar />
        <MainForm/>
      </AppContext.Provider>
    </div>
  );
}

export default App;
